import React, { useState } from "react";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { api, formatApiError } from "../lib/api";

const OPTIONS = [
  ["guests_only", "Guests only (never public)"],
  ["days_before", "Make public a few days before"],
  ["day_of", "Make public on the wedding day"],
  ["after_wedding", "Make public after the wedding"],
  ["public_now", "Public now"],
];

export function VenuePrivacyCard({ w }) {
  const [mode, setMode] = useState(w.venue_privacy || "guests_only");
  const [days, setDays] = useState(w.venue_public_days || 7);
  async function save(m = mode, d = days) {
    try { await api.put("/weddings/mine/venue-privacy", { venue_privacy: m, venue_public_days: Number(d) || 7 }); toast.success("Venue privacy saved"); }
    catch (e) { toast.error(formatApiError(e)); }
  }
  return (
    <div className="rounded-2xl bg-[var(--bg-warm)] p-4 space-y-2" data-testid="venue-privacy">
      <p className="text-sm font-medium flex items-center gap-1.5"><Lock className="w-3.5 h-3.5 text-[var(--gold)]" /> Who can see the exact venue?</p>
      <p className="text-xs text-[var(--muted)]">Everyone sees your city. Only people on your guest list (incl. bridal & groom party) see the venue until you choose to share it.</p>
      <select value={mode} onChange={(e) => { setMode(e.target.value); save(e.target.value, days); }} className="input-luxe" data-testid="venue-privacy-select">
        {OPTIONS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      {mode === "days_before" && (
        <label className="flex items-center gap-2 text-sm">
          <input type="number" min="1" max="365" value={days} onChange={(e) => setDays(e.target.value)} onBlur={() => save()} className="input-luxe !w-24" data-testid="venue-privacy-days" /> days before the wedding
        </label>
      )}
    </div>
  );
}
